// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_u0-0";
export var checkoutRateBadgeLink = "_u0-1";